export default __webpack_public_path__ + "whimsical.15ad9f73.png";